import { render, staticRenderFns } from "./AdminTab_Role_Create.vue?vue&type=template&id=d732d010&scoped=true"
import script from "./AdminTab_Role_Create.vue?vue&type=script&lang=js"
export * from "./AdminTab_Role_Create.vue?vue&type=script&lang=js"
import style0 from "./AdminTab_Role_Create.vue?vue&type=style&index=0&id=d732d010&prod&scoped=true&lang=css"
import style1 from "./AdminTab_Role_Create.vue?vue&type=style&index=1&id=d732d010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d732d010",
  null
  
)

export default component.exports